import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/aiVideo/initialState'
import reducers from 'store/features/aiVideo/reducers'

export const aiVideoSlice = createSlice({
  name: 'aiVideo',
  initialState: getInitialState(),
  reducers
})

export default aiVideoSlice
